import { useState } from 'react';

type Category = 'sleep' | 'stress' | 'clear';

const CATEGORIES = [
  {
    id: 'sleep' as Category,
    title: '수면 유도',
    image: require('../../assets/hanhwa/sleep.png'),
  },
  {
    id: 'stress' as Category,
    title: '스트레스 완화',
    image: require('../../assets/hanhwa/stress.png'),
  },
  {
    id: 'clear' as Category,
    title: '생각 비우기',
    image: require('../../assets/hanhwa/concentration.png'),
  },
];

function CategoryCard({
  title,
  image,
  selected,
  onClick,
}: {
  title: string;
  image: string;
  selected: boolean;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={`relative w-full max-w-[334px] h-[110px] rounded-xl overflow-hidden transition-all border-2 ${
        selected ? 'border-[#4F68FC]' : 'border-transparent'
      }`}
    >
      <img src={image || '/placeholder.svg'} alt={title} className="absolute inset-0 w-full h-full object-cover" />
    </button>
  );
}

export default function CategorySelectPage({ onNext }: { onNext: (category: Category) => void }) {
  const [selected, setSelected] = useState<Category | null>(null);

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex flex-col">
      <div className="flex-1 overflow-y-auto px-4 pt-8">
        <h2 className="text-white text-[22px] font-semibold text-center mb-8">어떤 효과를 원하시나요?</h2>

        <div className="w-full max-w-md mx-auto flex flex-col items-center gap-5 pb-6">
          {CATEGORIES.map((cat) => (
            <CategoryCard
              key={cat.id}
              title={cat.title}
              image={cat.image}
              selected={selected === cat.id}
              onClick={() => setSelected(cat.id)}
            />
          ))}
        </div>
      </div>

      <div className="sticky bottom-0 w-full bg-[#1A1A1A] pt-4 pb-6 shadow-[0_-4px_12px_[#1A1A1A]]">
        <div className="w-full max-w-sm mx-auto px-4">
          <button
            disabled={!selected}
            onClick={() => selected && onNext(selected)}
            className={`w-full h-[56px] rounded-full text-[16px] font-bold transition-all ${
              selected
                ? 'bg-[#4F68FC] text-white hover:brightness-110 active:scale-95'
                : 'bg-[#333D4B] text-[#4E5968] cursor-not-allowed'
            }`}
          >
            다음
          </button>
        </div>
      </div>
    </div>
  );
}
